<template>
  <div></div>
</template>

<script>
  import QRCode from 'qrcode-js-package'

  export default {
    props: {
      text: {type: String, required: true},
      size: {type: Number, default: 256},
      colorDark: {type: String, default: '#000'},
      colorLight: {type: String, default: '#FFF'}
    },

    data: function () {
      return {
        qrcode: {}
      }
    },
    mounted: function () {
      this.qrcode = new QRCode(this.$el, {
        text: this.text,
        width: this.size,
        height: this.size,
        colorDark: this.colorDark,
        colorLight: this.colorLight,
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    destroyed: function () {
      this.clear()
    },
    watch: {
      text: function () {
        this.clear()
        this.makeCode(this.text)
      }
    },
    methods: {
      clear: function () {
        this.qrcode.clear()
      },
      makeCode: function (text) {
        this.qrcode.makeCode(text)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// QrCode.vue?bc4c039a